<template>
  <div class="template page-view">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.page-view {
  margin-top: 0px;
}

.Banner {
  width: 100%;

  & .cover-image {
    height: 600px;
  }
}

.Content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 65px;

  .Main {
    &.-singlecolumn {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding-top: 65px;
    }

    &.-twocolumn {
      flex: 0 0 67%;
    }
  }

  .Sidebar {
    flex: 0 0 33%;
  }

  .Footer {
    flex: 1 0 100%;
  }
}
</style>
